import React, { useRef, useState } from 'react';
import DownloadTable from './DownloadTable';
import ListaLinhaValorDestacado from './ListaLinhaValorDestacado';
import { Link } from 'react-router-dom';

export default function ListaTransferencias(props) {
    const [valores, setValores] = useState(props.valores);
    const tableRef = useRef();

    const TableRows = () => {
        let criterio_id = null;
        const element = [];
        let total = 0.000000000;
        let totalCategoria = 0.000000000;
        for (let i = 0; i < valores.length; i++) {
            const valor = valores[i];

            valor.valor = !valor.valor ? 0.0 : valor.valor;
            totalCategoria = totalCategoria + parseFloat(valor.valor.toString().replaceAll('.', '').replaceAll(',', '.'));

            // somatorio por criterio
            valores.forEach(item => {
                if (item.criterio_id != null) {
                    if (item.criterio_id == valor.criterio_id) {
                        item.valor = !item.valor ? 0.0 : item.valor;
                        total = total + parseFloat(item.valor.toString().replaceAll('.', '').replaceAll(',', '.'));
                    }
                } else total = null;
            });

            if (valor.criterio_id != criterio_id) {
                element.push(
                    <tr key={''} className='bg-light'>
                        <th>
                            <span className='' style={{ textTransform: 'uppercase' }}>
                                {/* <i class="zmdi zmdi-caret-down"></i> */}
                                {valor.criterio}
                            </span>
                        </th>
                        <td> {valor.criterio_descricao} </td>
                        <td></td>
                        {/* <td></td> */}
                        <td>
                            {props.exibirTotal == true && <span className='text-left text-muted' style={{ textTransform: '', fontSize: '11px' }} > Valor total de {valor.criterio}  </span>}
                        </td>
                        <td className='text-right'>
                            {props.exibirTotal == true && <strong className='label bg-grey' style={{ fontSize: '13.3px' }}> {Intl.NumberFormat('pt-BR').format(total)} </strong>}
                        </td>
                    </tr>
                );
            }
            element.push(
                <tr key={''}>
                    <td className=""><ListaLinhaValorDestacado valor={valor.nome} destacado={valor.destacado} cor={'#8BC34A'} /> </td>
                    <td className=""> <span style={{ fontSize: '11px' }}>{valor.descricao}</span> </td>
                    <td className=""><Link to={'/parceiros'} style={{ color: 'black', textDecoration: 'none' }}> <small>{valor.fontes}</small> </Link> </td>
                    <td className=""> {valor.periodicidade} </td>
                    {/* <td className=""> {valor.unidade} </td> */}
                    <td className="text-right"> {valor.valor} </td>
                </tr>
            );
            criterio_id = valor.criterio_id;

        }

        element.push(
            <tr key={''}>
                <td className="text-left bg-light" style={{ color: 'black', fontWeight: 'bold' }}> TOTAL TRANSFERÊNCIAS </td>
                <td className="bg-light"> <span style={{ fontSize: '11px', display: 'none' }}> Soma dos valores transferidos levando em conta as  <b>Compensações Financeiras</b></span> </td>
                <td className="bg-light"> </td>
                <td className="bg-light"> </td>
                {/* <td className=""> {valor.unidade} </td> */}
                <td className="text-right bg-light" style={{ fontWeight: 'bold' }}> R$  {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(totalCategoria)} </td>
            </tr>
        );
        return element;
    }

    return (
        <>
            <DownloadTable tableRef={tableRef} template={props.valores[0]} />
            <table ref={tableRef} className="table  table-sm small table-hover" id='table_transferencias'>
                <thead>
                    <tr>
                        <th>CRITÉRIOS</th>
                        <th></th>
                        <th>FONTE</th>
                        <th>PERIODICIDADE</th>
                        {/* <th>UNIDADE</th> */}
                        <th className="text-right">VALOR (R$)</th>
                    </tr>
                </thead>
                <tbody>
                    <TableRows></TableRows>
                </tbody>
            </table>
        </>
    )
}

